<template>
  <div>
    <v-data-table
      :loading="loading"
      :headers="headers"
      :items="appcontent.data"
      :server-items-length="appcontent.meta.total"
      :options.sync="options"
      sort-by="name"
    >
      <template v-slot:item.type_id="{ item }">{{ item.type }}</template>
      <template v-slot:item.category_id="{ item }">{{
        item.category
      }}</template>

      <template v-slot:item.action="{ item }">
        <action-slot-component
          :item="item"
          route-name="forms.show"
          :route-params="{ id: item.id }"
          @show="$emit('show', item)"
        />
      </template>
    </v-data-table>
  </div>
</template>

<script>
import ActionSlotComponent from '@/modules/_global/_components/ActionSlotComponent.vue';

export default {
  name: 'AppContentList',
  components: { ActionSlotComponent },

  data: () => ({
    unwatch: null,
    appcontent: { meta: { total: 0 } },
    options: {}
  }),

  computed: {
    loading() {
      return this.$store.getters['loading'];
    },
    headers() {
      return [
        {
          text: this.$t('ITEM.ID'),
          align: 'left',
          sortable: true,
          value: 'id'
        },
        {
          text: this.$t('ITEM.NAME'),
          value: 'name'
        },
        {
          text: this.$t('DATA_TABLE.ACTIONS'),
          value: 'action',
          sortable: false,
          align: 'center'
        }
      ];
    }
  },

  watch: {
    options: {
      handler(e) {
        this.setData(e);
      },
      deep: true
    }
  },

  created() {
    this.unwatch = this.$store.watch(
      state => state.localization.lang,
      () => {
        const lang = this.$store.state.localization.lang;

        if (lang) {
          this.setData(this.options);
        }
      }
    );
  },

  destroyed() {
    this.unwatch();
  },

  methods: {
    setData(e) {
      this.$store
        .dispatch('form/getList', {
          pageNumber: e.page,
          itemsPerPage: e.itemsPerPage,
          sortBy: e.sortBy,
          orderBy: e.sortDesc[e.sortDesc.length - 1] ? 'desc' : 'asc'
        })
        .then(({ data }) => {
          this.appcontent = data;
        })
        .catch(error => {
          console.log('error');
          this.error = error.response;
        });
    }
  }
};
</script>
